import {createEventFilter,filterTransaction} from '../monitoring-privacy.mjs';
let sdk:typeof import('@sentry/react')|undefined;
type MonitoredUser={id:string;email?:string;username?:string}|null;
const pending:unknown[]=[];
let currentUser:MonitoredUser=null;
export function captureReactError(error:unknown){if(sdk)sdk.captureException(error);else if(pending.length<5)pending.push(error);}
// Called whenever the signed-in account changes, so every report names the affected account.
export function setMonitoringUser(user:MonitoredUser){currentUser=user?{id:user.id,email:user.email,username:user.username}:null;sdk?.setUser(currentUser);}
function clientTags(version?:string,session?:string){
 const agent=navigator.userAgent,desktop=(window as any).malvoDesktop;
 return {platform:desktop?.isDesktop?'desktop':/MALVOAndroidBeta/.test(agent)?'android':'web',malvo_version:version||'',session:session||'',locale:navigator.language,viewport:innerWidth+'x'+innerHeight};
}
export async function initMonitoring(){
 try{
  const response=await fetch('/api/monitoring-config',{credentials:'same-origin',signal:AbortSignal.timeout(1500)});
  if(!response.ok)return;
  const config=await response.json();
  if(typeof config.dsn!=='string'||!config.dsn)return;
  const Sentry=await import('@sentry/react');
  const traces=Number(config.tracesSampleRate)||0;
  Sentry.init({dsn:config.dsn,environment:config.environment,release:config.release,
   dataCollection:{userInfo:false,cookies:false,httpHeaders:false,httpBodies:[],urlQueryParams:false,graphQL:{document:false,variables:false},genAI:{inputs:false,outputs:false},mcp:{inputs:false,outputs:false}},beforeSendLog:()=>null,tracesSampleRate:traces,maxBreadcrumbs:0,
   ...(traces?{integrations:[Sentry.browserTracingIntegration()]}:{}),
   beforeSend:createEventFilter({component:'frontend',firstParty:/^(?:app-[A-Z0-9]+|gif-crop-worker)\.js$/}),beforeSendTransaction:filterTransaction});
  Sentry.setTags(clientTags(config.version,config.session));
  Sentry.setContext('screen',{width:screen.width,height:screen.height,pixel_ratio:devicePixelRatio,online:navigator.onLine});
  Sentry.setUser(currentUser);
  sdk=Sentry;for(const error of pending.splice(0))sdk.captureException(error);
  return Sentry;
 }catch{return;}// Monitoring failure must not block chat/login.
}
